import { FaCaretLeft } from "react-icons/fa";
import { useHistory } from "react-router-dom";

function BackButton({className}) {
    const history = useHistory();

    return (
        <div className={"d-flex align-items-center backbutton-withlines justify-content-center" + " " + (className?className:"")} onClick={()=>{history.goBack();}}>
            <div className="arrow-container" style={{ width: "250px" }}>
                <h4 style={{ color: "black!important", fontWeight: "lighter", fontSize: "20px" }} className="ml-2 d-flex align-items-center mb-1"><FaCaretLeft size="22" />TERUG</h4>
                <hr className="top-hr text-left mb-0 ml-3 mt-0" />
                <hr className="top-hr-1 text-left mt-0 ml-3 mb-0" />
            </div>
        </div>
    );
}

export default BackButton;